import { IUserAccount } from 'features/UserAccount/types'

export const getUserFullName = (userAccount: IUserAccount): string => {
  return `${userAccount.firstName} ${userAccount.lastName}`
}
